import { render, staticRenderFns } from "./DIAGInconsistenciaDados.vue?vue&type=template&id=c9b640f8&"
import script from "./DIAGInconsistenciaDados.vue?vue&type=script&lang=js&"
export * from "./DIAGInconsistenciaDados.vue?vue&type=script&lang=js&"
import style0 from "./DIAGInconsistenciaDados.vue?vue&type=style&index=0&id=c9b640f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports